import React, {useEffect} from "react";
import gql from "graphql-tag";
import ActionButton from "../../components/ActionButton";
import {useDispatch} from "react-redux";
import {requestEditNote} from "../NotesActions";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import PanelGroupController from "../../components/PanelGroupController";
import { fromJS } from "immutable";
import {useQuery} from "@apollo/react-hooks";
import NoteView from "./NoteView";

export default function NotePanel(props) {
  const dispatch = useDispatch();
  let {noteId, expanded} = props;
  let {loading, error, data, subscribeToMore, refetch} = useQuery(GET_NOTE, {variables: {noteId: noteId}, skip: !noteId});

  useEffect(() => {
    if (noteId) {
      let unsubscribe = subscribeToMore({
        document: ON_UPDATED_NOTE,
        variables: {noteId: noteId},
        updateQuery: (prev, {subscriptionData}) => {
          if (!subscriptionData.data) return prev;
          refetch();
          return prev;
        }
      });

      return () => {
        unsubscribe();
      }
    }
  }, [noteId, refetch]);

  if (!noteId) {
    return (
      <Wrapper expanded={expanded}>
        <p className="u-no-selection">Nothing selected</p>
      </Wrapper>
    )
  }

  if (loading) {
    return (
      <Wrapper expanded={expanded}>
        <Loading />
      </Wrapper>
    )
  }

  if (error) {
    return (
      <Wrapper expanded={expanded}>
        <GraphQLErrors error={error} />
      </Wrapper>
    )
  }

  let note = fromJS(data.note);

  return (
    <Wrapper expanded={expanded}>
      <NoteView 
        data={note} 
        showTitle={false} />
      <ActionButton label="Edit Note" onClick={() => dispatch(requestEditNote(noteId))} />
    </Wrapper>
  )
}

function Wrapper({expanded, children}) {
  return (
    <PanelGroupController title="Note" expanded={expanded}>
      {children}
    </PanelGroupController>  
  )
}

const ON_UPDATED_NOTE = gql`
  subscription updatedNote($noteId:ID!){
    updatedNote(noteId: $noteId) {
      id
      action
    }
  }
`

export const GET_NOTE = gql`
  query note($noteId:ID!) {
    note(noteId: $noteId) {
      noteId,
      foreignId,
      foreignType,
      status,
      title,
      descriptionHtml,
      tags,
      createdBy,
      createdByName,
      updatedBy,
      updatedByName,
      insertedAt,
      updatedAt,
    }
  }
`;